import { Form } from "@/components/organisms/Form";
import { Buttons } from "@/components/atoms/Buttons";
import { AlertPwBox } from "@/components/molecules/AlertPwBox";
import { useNavigate } from "react-router";
import { MainTemplate } from "@/components/templates/MainTemplate";

export const CheckPwPage = () => {
  const navigate = useNavigate();
  return (
    <MainTemplate nav={false} subPage={false} menuBtn={false}>
      <Form
        submitBtn={
          <Buttons
            type="submit"
            size="lg"
            color="primary100"
            layout="solid"
            label="로그인하기"
            onClick={() => navigate("/auth/login")}
          />
        }
      >
        <AlertPwBox />
      </Form>
    </MainTemplate>
  );
};
